import React, {useEffect, useState} from 'react'
import {HomePage} from './view/HomePage';
import {HomePageApi} from "./HomePageApi";
import {HomePageResponseJson, MediaItemJson} from "./interfaces";
import {EMPTY_STRING} from "../../utils/CommonConstants";
import {useTranslation} from "react-i18next";
import {LocalStorageApi} from "../../utils/LocalStorageApi";
import {useHistory, useLocation} from "react-router";
import {LINK} from "../../utils/Links";

const HomePageContainer = () => {

    const history = useHistory();
    const [homePageData, setHomePageData] = useState<HomePageResponseJson>({
        date: EMPTY_STRING,
        from: EMPTY_STRING,
        size: EMPTY_STRING,
        subject: EMPTY_STRING,
        to: EMPTY_STRING,
        messages: [],
        images: [],
        videos: [],
        audios: [],
        unrecognized: [],
        url: EMPTY_STRING
    });

    const location = useLocation<HomePageResponseJson>();
    const [alertVisible, setAlertVisible] = useState<boolean>(false);
    const {t, i18n} = useTranslation('home');

    const b64toBlob = (base64, type = 'application/octet-stream') =>
        fetch(`data:${type};base64,${base64}`).then(res => res.blob());

    const handleDownloadMedia = (mediaItemJson: MediaItemJson) => {
        b64toBlob(mediaItemJson.data, mediaItemJson.contentType)
            .then(file => {
                let a = document.createElement("a");
                a.href = URL.createObjectURL(file);
                a.download = mediaItemJson.filename;
                document.body.appendChild(a);
                a.click();
            });
    };


    const handleRefresh = () => {
        HomePageApi.getHomePageData(LocalStorageApi.getAccessToken())
            .then((response: HomePageResponseJson) => {
                setHomePageData(response);
                LocalStorageApi.setDispatcherUrl(response.url)
            })
            .catch((reason) => handleErrorStatus(reason.response.status));
    };

    const handleLogout = () => {
        HomePageApi.logout(LocalStorageApi.getAccessToken(), LocalStorageApi.getDispatcherUrl())
            .then(() => {
                LocalStorageApi.removeAccessToken();
                LocalStorageApi.removeDispatcherUrl();
                history.push(LINK.SIGNIN);
            }).catch((reason) => {
            handleErrorStatus(reason.response.status);
        });
    };

    const handleCloseAlert = () => {
        setAlertVisible(false);
    };

    const handleChangeLanguage = (language: string) => {
        i18n.changeLanguage(language)
    };

    const handleErrorStatus = (status: number) => {
        if (status == 401) {
            //non-blocking
            HomePageApi.logout(LocalStorageApi.getAccessToken(),LocalStorageApi.getDispatcherUrl());
            LocalStorageApi.removeAccessToken();
            LocalStorageApi.removeDispatcherUrl();
            history.push(LINK.SIGNIN)
        } else {
            setAlertVisible(true);
        }
    };

    useEffect(() => {
        if (location.state == undefined) {
            HomePageApi.logout(LocalStorageApi.getAccessToken(),LocalStorageApi.getDispatcherUrl());
            LocalStorageApi.removeAccessToken();
            LocalStorageApi.removeDispatcherUrl();
            history.push(LINK.SIGNIN);
        } else {
            LocalStorageApi.setDispatcherUrl(location.state.url);
            setHomePageData(location.state);
        }

    }, [location]);


    return <HomePage homePageData={homePageData}
                     onClickDownloadMedia={handleDownloadMedia}
                     t={t}
                     onClickLanguage={handleChangeLanguage}
                     onClickRefresh={handleRefresh}
                     onClickLogout={handleLogout}
                     alertVisible={alertVisible}
                     onClickClose={handleCloseAlert}/>
};

export default HomePageContainer;